/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Embed_Files_SuccessInputs */



/**
* | output |
* | --- |
* | "Files embedded successfully!" |
*
* @param {Spaces_Embed_Files_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_embed_files_success = /** @type {((inputs?: Spaces_Embed_Files_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Embed_Files_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateien erfolgreich eingebettet!")
	return /** @type {LocalizedString} */ ("Files embedded successfully!")
});